/**
 * Created by sumudu on 11/23/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name profile.crewProfileAdaptorFactory
     *
     * @description
     *
     */
    angular
        .module('crewProfile')
        .factory('profileAdaptorFactory', profileAdaptorFactory);

    function profileAdaptorFactory() {

        var _getDefaultValidationsAdaptor = function(response){
            return (response && response.crewDefaultValidationList) || [];
        };

        var _getCrewTypeValidationAdaptor = function(response){
            //default select mandatory fields
            angular.forEach(response.crewDefaultValidationList, function (validation) {
                if(validation.isMandatory == 'Y'){
                    validation.isAssigned = 'Y';
                }
            });
            return (response.crewDefaultValidationList) || [];
        };

        return {
            getDefaultValidationsAdaptor : _getDefaultValidationsAdaptor,
            getCrewTypeValidationAdaptor : _getCrewTypeValidationAdaptor
        };
    }

})();